// src/services/oauthApi.ts
import { API_DOMAIN } from '@/services/apiConfig';

export async function fetchOAuthLoginUrl(language: 'th' | 'en' = 'th'): Promise<string> {
  const url = `${API_DOMAIN}/v7/service/admd/web/oauth?appTemplate=website&language=${language}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  const data = await res.json();
  // Expecting { code, message, responseObject: { link } }
  if (!data.responseObject?.link) throw new Error('No OAuth link in response');
  return data.responseObject.link;
}

// Exchange OAuth code for access token with device info
export async function exchangeOAuthCodeForToken(
  code: string,
  deviceId: string,
): Promise<unknown> {
  const browserVersion = window.navigator.appVersion.split(' ')[0];
  const browserPlatform = window.navigator.platform;
  const browserVendor = window.navigator.vendor;
  const browserProduct = window.navigator.product + window.navigator.productSub;

  const form = new FormData();
  form.append('authCode', code);
  form.append('deviceId', deviceId);
  form.append('ffbidBox', '');
  form.append('clientType', 'website');
  form.append('serial', browserProduct);
  form.append('osVersion', browserVersion);
  form.append('model', browserPlatform);
  form.append('brand', browserVendor);
  form.append('osClient', '');

  const url = `${API_DOMAIN}/web/service/subscribe`;
  // const url = `${API_DOMAIN}/v7/service/subscribeMobile`;
  const res = await fetch(url, {
    method: 'POST',
    body: form,
  });

  if (!res.ok) throw new Error(`Token exchange failed: ${res.status}`);
  return await res.json();
}
